/**
 * PERSON AVATAR — Cerchio con iniziale del cognome (fallback firstName,
 * fallback '?'), uppercase. Riusabile in detail page (size='lg') e in
 * tabelle list (default).
 *
 * Logica di calcolo iniziale + classi CSS (.avatar / .avatar--lg) viene
 * esposta da un solo punto: ogni call-site del progetto la usa via questo
 * componente per garantire coerenza visiva.
 */

//TODO (in futuro ci sarà immagine associata a persona, direttamente o indirettamente tramite business e potremo mostrare quella invece dell'iniziale).

interface PersonAvatarProps {
  firstName?: string | null;
  lastName?: string | null;
  /** 'lg' = 40×40 (detail page header). Default = 32×32 (cell tabelle). */
  size?: 'lg';
}

export function PersonAvatar({ firstName, lastName, size }: PersonAvatarProps) {
  const initial = (lastName?.charAt(0) ?? firstName?.charAt(0) ?? '?').toUpperCase();
  const className = size === 'lg' ? 'avatar avatar--lg' : 'avatar';
  return <div className={className}>{initial}</div>;
}
